import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ExploreContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 100px;
  padding: 0 20px;
`;

const Card = styled.div`
  width: calc(33.3333% - 40px);
  margin: 20px;
  @media (max-width: 768px) {
    width: calc(50% - 40px);
  }
  @media (max-width: 576px) {
    width: calc(100% - 40px);
  }
`;

const Explore = () => {
  return (
    <ExploreContainer>
      {/* Card 1 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/R.59228416161ec617d7e4e612a7db8ff2?rik=M4nPRbJRc7v%2bWw&pid=ImgRaw&r=0"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Simple Menu</h5>
            <p className="card-text">
              This is a simple restaurant menu app created for fun. In this app, you can see the menu and filter it. Created by: <code>Sahil</code>
            </p>
            <Link to="/res" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </div>
      </Card>

      {/* Card 2 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/OIP.spOJmOlp5IegqBPDKSouzQHaHa?rs=1&pid=ImgDetMain"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Quiz Game</h5>
            <p className="card-text">
              This is a simple quiz game where you answer questions and earn points. Game asked you question you should need to choose any option and click next. Created by: <code>Sahil</code>
            </p>
            <Link to="/quiz" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </div>
      </Card>

      {/* Card 3 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/OIP.-XcFyGduyZipjo221zLzXgHaHa?rs=1&pid=ImgDetMain"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Bubble Game</h5>
            <p className="card-text">
              This is a bubble game where you have 1 minute to click on bubbles and earn points. Created by: <code>Sahil</code>
            </p>
            <Link to="/bbl" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </div>
      </Card>

      {/* Card 4 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/R.5564fedba3f57e788a03447b9583af1a?rik=ml87lZw0V%2fcV7Q&pid=ImgRaw&r=0"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Weather Info</h5>
            <p className="card-text">
              This is a weather app where you can search and see weather information for any location. Created by: <code>Sahil</code>
            </p>
            <Link to="/sky" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </div>
      </Card>

      {/* Card 5 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/OIP.7udy4r-k9TSRRE0EuAJXAQHaHy?rs=1&pid=ImgDetMain"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Simple Calculator</h5>
            <p className="card-text">
              This is a simple calculator where you can perform basic calculations. Created by: <code>Sahil</code>
            </p>
            <Link to="/calc" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </div>
      </Card>

      {/* Card 6 */}
      <Card>
        <div className="card">
          <img
            className="card-img-top"
            src="https://yt3.googleusercontent.com/x1Qg8bPhjX_Z6JiJr4vuUAM2vcibYYi3TQy0hnhZvnhfX7vNwczEJAyqUB420AF39WmGaYfpVg=s900-c-k-c0x00ffffff-no-rj"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Anime Versee</h5>
            <p className="card-text">
              This is an Anime website where you can search for any anime and get details, including trailers. Created by: <code>Sahil</code>
            </p>
            <a className="btn btn-primary" href="https://anime-versee.netlify.app/">Visit</a>
          </div>
        </div>
      </Card>
    </ExploreContainer>
  );
};

export default Explore;
